import React, { useState } from "react";
import Navbar from "../componets/Navbar/Navbar";
import { Outlet } from "react-router-dom";
import ToggleNav from "../componets/Navbar/ToggleNav";
import MobileView from "../componets/Navbar/MobileView";

export default function Layout() {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => setIsOpen((prevState) => !prevState);
  const handleClose = () => setIsOpen(false);

  return (
    <div className="block md:grid md:grid-cols-12 w-full">
      <div className="md:hidden">
        <ToggleNav isOpen={isOpen} onToggle={handleToggle} />
        <MobileView showMenu={isOpen} onClose={handleClose} />
      </div>
      <div className="hidden md:flex justify-center items-center border-r border-[#937c7c] bg-[#fcecd8] md:px-6 lg:px-8 w-full md:col-span-1">
        <Navbar />
      </div>
      <div className="md:col-span-11 pt-14 md:pt-0">
        <Outlet />
      </div>
    </div>
  );
}